// (C) Copyright 2025 Hewlett Packard Enterprise Development LP
import React from 'react'
import { Avatar } from 'grommet'
import { useReactOidc } from '@axa-fr/react-oidc-context'

import { parseCurrentUser, getUserNameChars } from './utils'

const UserAvatar = () => {
  const { oidcUser } = useReactOidc()
  return (
    <Avatar background="background-contrast">
      {getUserNameChars(parseCurrentUser(oidcUser))}
    </Avatar>
  )
}

export { UserAvatar }
